/**
 * @component {"type":"SkipQuizStart","version":"1.1"}
 * @component {"type":"NavigationSettings","version":"1.0"}
 */

define('navigation',['helpers', 'utils', 'navigation-validation', 'navigation-transition', 'training', 'user-answers', 'pubsub'], function(helpers, utils, Validation, Transition, Training, UserAnswers, PubSub) {
    'use strict';

    var navigation,
        training,
        userAnswers;

    function Navigation(options) {
        options = options || {};

        this.swiping = options.swiping || {
            touchDevices: true,
            nonTouchDevices: false
        };

        this.validation = new Validation({
            navigation: this
        });

        this.transition = new Transition(options);

        this.viewModel = options.viewModel || {};

        if (this.swiping.touchDevices && utils.isTouchDevice || this.swiping.nonTouchDevices && !utils.isTouchDevice) {
            this.initSwipe();
        }
    }

    Navigation.prototype.getIndex = function(target, map) {
        var index = -1;

        if (Number.isInteger(target)) {
            index = (target > map.length) ? map.length : target - 1;
        } else {
            index = map.indexOf(target);
        }

        return index;
    };

    Navigation.prototype.getParentID = function(ID) {
        var entity = training.getEntity(ID),
            parentID = (entity && entity.contentEntity.parentId) ? entity.contentEntity.parentId : '';

        return (parentID && parentID !== training.containerID) ? parentID : '';
    };

    Navigation.prototype.getModularSectionID = function(ID) {
        var parentID = this.getParentID(ID);

        return (parentID) ? this.getModularSectionID(parentID) : ID;
    }

    Navigation.prototype.getCurrentMap = function(ID) {
        var game;

        if (helpers.entity.isQuizTaskPage(ID, training.contentEntities)) {
            return this.getQuizMap(ID);
        }

        game = helpers.content.getQuizGame(ID, training.contentEntities);

        if (game.isQuizGame && ID !== game.ID) {
            return this.getQuizGameMap(game.ID);
        }

        return training.trainingMap;
    };

    Navigation.prototype.isLastInModularSection = function(ID) {
        var progress,
            getLastID = function(ID) {
                var entity = training.getEntity(ID);

                if (entity && Array.isArray(entity.children) && entity.children.length && entity.typeId !== 19) {
                    return getLastID(entity.children[entity.children.length - 1].contentEntityId);
                } else {
                    return ID;
                }
            },
            sectionID = this.getModularSectionID(ID);

        if (!sectionID) {
            return false;
        }

        if (helpers.entity.isQuizTaskPage(ID, training.contentEntities)) {
            progress = userAnswers.getQuizPageProgress(sectionID);

            return (progress && Array.isArray(progress.childrenID) && progress.childrenID[progress.childrenID.length - 1] === ID) ? true : false;
        }

        return (getLastID(sectionID) === ID) ? true : false;
    };

    Navigation.prototype.getTargetID = function(ID, target, dir) {
        var index = 0,
            currentMap = this.getCurrentMap(ID),
            targetID,
            progress;

        dir = (dir) ? dir.toLowerCase() : '';

        if (!target && dir) {

            index = this.getIndex(ID, currentMap);

            switch(dir) {
                case 'forward':
                    if (training.modularMenuPageID && this.isLastInModularSection(ID)) {
                        return training.modularMenuPageID;
                    } else if (index > -1) {
                        index++;
                    }
                    break;
                case 'back':
                    if (training.modularMenuPageID && !this.getParentID(ID)) {
                        return training.modularMenuPageID;
                    } else if (index > -1) {
                        index--;
                    }
                    break;
            }

            if (index > -1 && index < currentMap.length) {
                targetID = currentMap[index];
            } else {
                // targetID = helpers.entity.isQuizTaskPage(ID, training.contentEntities) ? this.getParentID(ID) : null;
                progress = userAnswers.getQuizProgress(ID);

                targetID = progress ? progress.ID : this.getParentID(ID) || null;
            }

        } else if (Number.isInteger(target)) {
            index = (target > 0) ? target - 1 : target;
            targetID = currentMap[index];
        } else {
            targetID = target;

            if (training.modularMenuPageID && dir === 'back' && this.isLastInModularSection(ID)) {
                targetID = training.modularMenuPageID;
            }
        }

        return targetID;
    };

    Navigation.prototype.getQuizGameMap = function(ID) {
        var res = [],
            entity = training.getEntity(ID),
            children = (entity && Array.isArray(entity.children)) ? entity.children : [],
            childrenID;

        if (!children.length) {
            return res;
        }

        for (var i = 0; i < children.length; i++) {
            childrenID = children[i].contentEntityId;

            if (children[i].typeId === 19) {
                var progress = userAnswers.getQuizPageProgress(childrenID);

                if (progress && Array.isArray(progress.childrenID)) {
                    res = res.concat(progress.childrenID);
                }
            }

            res.push(childrenID);
        }

        return res;
    };

    Navigation.prototype.getQuizMap = function(ID) {
        var progress = userAnswers.getQuizProgress(ID);

        return (progress && progress.childrenID) ? progress.childrenID : [];
    };

    Navigation.prototype.initSwipe = function() {
        var _this = this;

        require(['hammer'], function(Hammer) {
            var timeoutID,
                player = document.getElementById('player'),
                content = document.getElementById('content'),
                layout = document.getElementById('js-layout-content'),
                props = {
                    recognizers: [
                        [Hammer.Swipe, {direction: Hammer.DIRECTION_HORIZONTAL}],
                    ]
                },
                managers = {
                    player: new Hammer.Manager(player, props),
                    content: new Hammer.Manager(content, props),
                    layout: new Hammer.Manager(layout, props),
                },
                swipe = function(e) {
                    var direction = e.direction || 0;

                    if (timeoutID) {
                        clearTimeout(timeoutID);
                    }

                    timeoutID = setTimeout(function() {
                        var body = document.body;

                        if (body.classList.contains('no-navigation-swipe') || e.target.classList.contains('no-navigation-swipe') || e.srcEvent.srcElement.classList.contains('no-navigation-swipe')) {
                            return;
                        }

                        if (direction === 2) {
                            _this.navigateToDir('forward');
                        } else if (direction === 4) {
                            _this.navigateToDir('back');
                        }
                    }, 10);
                }

            managers.player.on('swipe', swipe);
            managers.content.on('swipe', swipe);
            managers.layout.on('swipe', swipe);
        });
    };

    Navigation.prototype.setViewModel = function(viewModel) {
        this.viewModel = viewModel;
    }

    Navigation.prototype.navigateToDir = function(dir) {
        var ID = this.viewModel.entity.ID(),
            targetID = this.getTargetID(ID, null, dir);

        if (!targetID) {
            return;
        }

        this.viewModel.training.goTo(targetID, true, dir);
        // this.navigateTo(targetID); // - missing validation errors
    };

    Navigation.prototype.getProperties = function(ID, targetID, dir) {
        var target = training.getContent(targetID),
            res = {
                entity: null,
                targetID: targetID,
                transition: null
            };

        dir = (dir) ? dir.toLowerCase() : '';

        if (helpers.entity.isQuizTaskPage(ID, training.contentEntities) || helpers.entity.isQuizTaskPage(targetID, training.contentEntities)) {
            res.transition = 'none';
        }

        if (target && helpers.entity.isQuizPage(target)) {
            var index,
                progress = userAnswers.getQuizPageProgress(targetID);

            if (progress) {

                if (!progress.isAnswered && !progress.isVisited) {
                    var content = helpers.component.getContent(target.componentsJSON, 'SkipQuizStart');

                    if (content.skip && Array.isArray(progress.childrenID) && progress.childrenID.length) {
                        res.targetID = progress.childrenID[0];
                        res.entity = training.getEntity(res.targetID);
                    }
                }

                if (dir !== 'back' && helpers.entity.isQuizTaskPage(ID, training.contentEntities) && (progress.isVisited || progress.isPassed)) {

                    if (target.skipFeedback) {
                        res.transition = null;

                        index = training.trainingMap.indexOf(targetID) + 1;

                        if (index) {
                            res.targetID = training.trainingMap[index] || res.targetID;
                        }
                    }
                }
            }
        }

        return res;
    }

    Navigation.prototype.navigateTo = function(targetID, swiping, dir) {
        var ID = this.viewModel.entity.ID(),
            prop,
            _this = this;

        if (!targetID || targetID === ID) {
            return;
        }

        prop = this.getProperties(ID, targetID, dir);

        PubSub.publish('navigate-to', {
            ID: ID,
            targetID: prop.targetID
        });

        this.transition.initLoading(swiping, dir, prop.transition, function() {
            _this.viewModel.updateVM(prop.targetID, prop.entity);
        });
    };

    Navigation.prototype.validate = function(options) {
        options = options || {};

        return this.validation.validate(options);
    };

    return function(options) {

        if (!navigation) {
            training = new Training();
            userAnswers = new UserAnswers();
            navigation = new Navigation(options);
        }

        return navigation;

    };

});

